var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-link',{attrs:{"target":"_blank","href":_vm.url}},[_vm._v("点击下载")])}
var staticRenderFns = []

export { render, staticRenderFns }